module.exports = __webpack_public_path__ + "static/media/coffee-break.d4c48fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/coffee-break.jpg
// module id = 467
// module chunks = 0